import { isFeatureEnabled } from 'owa-feature-flags';

export function isGetStartedPhoneCardControlEnabled() {
    return isFeatureEnabled('getStarted-PhoneCardcf');
}
